import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import styled, { css, useTheme } from 'styled-components'
import { BsBoxArrowUpRight } from 'react-icons/bs'
import { removeDomainFromLink } from 'utils'
import { StyledButton, StyledButtonOutlined } from 'components/LinkButton/styles'
import { pxToRem } from 'styles/functions'

const slideButtonSizing = css`
  width: auto;
  max-width: 100%;
  margin: 0;

  label {
    gap: 8px;
  }

  svg {
    flex-shrink: 0;
  }

  ${({ $iconOnly, $flat }) =>
    $iconOnly &&
    css`
      padding: ${pxToRem($flat ? 6 : 12)};
      aspect-ratio: 1;
      border-radius: 50%;
    `}
`

const SlideStyledButton = styled(StyledButton)`${slideButtonSizing}`
const SlideStyledButtonOutlined = styled(StyledButtonOutlined)`${slideButtonSizing}`

const SlideButton = ({ slide, themeInfos }) => {
  const theme = useTheme()
  const router = useRouter()

  const alternate = !!slide.buttonStyle?.alternate
  const flat = !!slide.buttonStyle?.flat

  const outlined = theme?.button_outlined_as_default ? !alternate : alternate
  const ButtonStyle = outlined ? SlideStyledButtonOutlined : SlideStyledButton

  const hasText = !!slide.buttonText

  return (
    <div className="embla__slide__action">
      <ButtonStyle
        href={slide.buttonUrl && removeDomainFromLink(slide.buttonUrl, router.query.appId, router.asPath)}
        data-dataga="slide link button"
        aria-label={hasText ? undefined : slide.buttonUrl}
        $flat={flat}
        $themeCustom={themeInfos}
        $iconOnly={!hasText}
      >
        <label>
          {hasText && <span>{slide.buttonText}</span>}
          <BsBoxArrowUpRight aria-hidden="true" />
        </label>
      </ButtonStyle>
    </div>
  )
}

SlideButton.propTypes = {
  slide: PropTypes.shape({
    buttonUrl: PropTypes.string,
    buttonText: PropTypes.string,
    buttonStyle: PropTypes.shape({
      alternate: PropTypes.bool,
      flat: PropTypes.bool,
    }),
  }).isRequired,
  themeInfos: PropTypes.object,
}

export default SlideButton
